import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default function HolidayShippingDatesModal(props) {
  const shippingDates = props.shippingDates;
  const now = new Date();
  const isDecember = now.getMonth() === 11;
  const title = ((isDecember && now.getDate() > 5 && now.getDate() <= 25)
    ? 'Holiday FedEx Special Discount'
    : 'Holiday Shipping Dates');
  const colors = ['#EEE', '#FAA', '#0C0'];
  const [showModal, setShowModal] = useState(false);
  const [foreColor, setForeColor] = useState('#F88');
  useEffect(() => {
    const interval = setInterval(function () {

      const nextColor = (colors.indexOf(foreColor) === colors.length - 1 ? 0 : colors.indexOf(foreColor) + 1);
      setForeColor(colors[nextColor]);
    }, 1500);
    return () => clearInterval(interval);
  });

  return <>
    <div
      title={title}
      onClick={() => setShowModal(!showModal)} className={props.className}
      style={{ color: foreColor, marginRight: '30px', fontSize: '0.8em', fontWeight: 'bold', cursor: 'pointer' }}>
      <i className='fa fa-snowflake' aria-hidden="true"></i>
      &nbsp;&nbsp;{title}
    </div>
    <Modal
      style={{ minWidth: "min-content" }}
      isOpen={showModal}
      toggle={() => setShowModal(!showModal)}>
      <ModalHeader
        toggle={() => setShowModal(!showModal)}>
        {title}
      </ModalHeader>
      <ModalBody><>
        <strong style={{ color: '#C44042' }}>Physical cards shipping</strong>
        <blockquote className="m-4">
          <dl>
            <dt>USPS - United States Postal Service</dt>
            <dd>
              <ul>
                <li>First Class: Order before noon EST {shippingDates["USPS:FirstClass"]} (No tracking)</li>
                <li>Priority: Order before noon EST {shippingDates["USPS:Priority"]}
                  {props.showFreeHolidayShipping &&
                    <strong style={{ color: '#f00' }}>&nbsp;&nbsp;Now FREE</strong>
                  }
                </li>
                <li>Express: Order before noon EST {shippingDates["USPS:Express"]}</li>
              </ul>
            </dd>
            <dt>FedEx: <em>Recommended</em> </dt>
            <dd>
              <ul>
                <li>3 Day Express Saver - Order before noon EST {shippingDates["FedEx:3DayExpressSaver"]}</li>
                <li>Standard Overnight - Order before noon EST {shippingDates["FedEx:StandardOvernight"]}</li>
              </ul>
            </dd>
          </dl>
          {isDecember &&
            <div style={{ color: '#f00', marginLeft: '80px' }}>
              <em>Holiday Special</em> -
              Only $6 for FedEx 3 Day
            </div>}
        </blockquote>
        <br />
        (all are shipped from Midwest)
        <br />
        <br />
        <strong style={{ color: '#800' }}>We strongly recommend expedited shipping.
          <br />
          USPS first class mail is without tracking and is often subject to delays during holiday season, and you
          may not receive your order in time. </strong>
        <br />
        <br />
        Note: Inclement weather and other factors may cause shipping delays; we cannot be
        responsible for such.
        {isDecember &&
          <span style={{ fontSize: '7pt', color: '#C44042' }}>
            <em>Holiday Special</em> -
            <span>{props.showFreeHolidayShipping ? 'FREE Priority Shipping' : 'FedEx Only $6 for your entire order'}</span>
          </span>}
      </></ModalBody>
    </Modal >
  </>;
}